import { useHomePageFeature } from '@/hooks/featureFlags';
import { NavigationItem } from '@/types/navigation';
import { useAccountNavigationItem } from './useAccountNavigationItem';
import { useAssistNavigationItem } from './useAssistNavigationItem';
import { useExploreNavigationItem } from './useExploreNavigationItem';
import { useHomeNavigationItem } from './useHomeNavigationItem';
import { useKeeperNavigationItem } from './useKeeperNavigationItem';
import { useLeagueNavigationItem } from './useLeagueNavigationItem';
import { useMatchNavigationItem } from './useMatchNavigationItem';
import { usePlayerNavigationItem } from './usePlayerNavigationItem';
import { useRecruitmentListNavigationItem } from './useRecruitmentListNavigationItem';
import { useTacticsNavigationItem } from './useTacticsNavigationItem';
import { useTeamNavigationItem } from './useTeamNavigationItem';
import { useVideoPlaylistNavigationItem } from './useVideoPlaylistNavigationItem';

export const useCrossPlatformNavigationItems = () => {
  const recruitmentListNavigationItem = useRecruitmentListNavigationItem();
  const homeNavigationItem = useHomeNavigationItem();
  const isHomePageEnabled = useHomePageFeature();

  const navigationItems: { primary: NavigationItem[]; footer: NavigationItem[] } = {
    primary: [
      ...(isHomePageEnabled ? [homeNavigationItem] : []),
      useVideoPlaylistNavigationItem(),
      usePlayerNavigationItem(true),
      useKeeperNavigationItem(),
      useTeamNavigationItem(),
      useMatchNavigationItem(),
      useLeagueNavigationItem(),
      useTacticsNavigationItem(),
      useExploreNavigationItem(),
      recruitmentListNavigationItem,
    ],
    footer: [useAssistNavigationItem(), useAccountNavigationItem()],
  };
  return navigationItems;
};
